<template>
  <div class="pagination py-3 align-center layout column">
    <div class="layout no-wrap align-center justify-center">
      <div
        v-for="step in steps"
        :key="step"
        :class="`${step === currentStep ? 'active' : 'pagination-not-active'} step`"
        class="pagination-signal"
      />
    </div>
    <div class="sub-header mt-2 layout justify-center">{{ currentStep }} / {{ steps }}</div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    steps: Number,
    currentStep: Number
  }
};
</script>

<style scoped>
.step {
  height: 3px;
  width: 35px;
}
.step:not(:first-child) {
  margin-left: 10px;
}
.active {
  background-color: var(--lightish-blue);
}
.pagination-not-active {
  background-color: #d8d8d8;
}
.sub-header {
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.9px;
  text-align: center;
  color: #4a4a4a;
}
</style>
